<script setup>
import { computed } from "vue";
import { scoreColor as toScoreColor } from "@/common/humanly/fitScore";

const props = defineProps({
  score: {
    type: Number,
    default: null,
  },
  badge: {
    type: Boolean,
  },
});

const scoreColor = computed(() =>
  toScoreColor(props.score)
);

const formattedScore = computed(() => {
  return (props.score * 10).toFixed(1);
});
</script>

<template>
  <span v-if="score == null" class="text-color-black-50 font-weight-500"
    >N/A</span
  >
  <div v-else-if="badge" class="score-badge" :class="scoreColor">
    {{ formattedScore }}
  </div>
  <div v-else class="score-display" :class="scoreColor">
    {{ `${formattedScore} / 10` }}
  </div>
</template>

<style scoped lang="scss">
.score-display.green {
  color: $tf-color-success;
}

.score-display.yellow {
  color: $tf-color-warning;
}

.score-display.red {
  color: $tf-color-danger;
}

.score-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  font-size: 14px;

  &.green {
    background-color: $tf-color-success;
  }

  &.yellow {
    background-color: $tf-color-warning;
  }

  &.red {
    background-color: $tf-color-danger;
  }
}
</style>
